import { render, staticRenderFns } from "./publishBook.vue?vue&type=template&id=6060df06&scoped=true&"
import script from "./publishBook.vue?vue&type=script&lang=js&"
export * from "./publishBook.vue?vue&type=script&lang=js&"
import style0 from "./publishBook.vue?vue&type=style&index=0&id=6060df06&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6060df06",
  null
  
)

export default component.exports